module.exports = __webpack_public_path__ + "img/zxzf.88e5a920.svg";